import { render } from "./Register.vue?vue&type=template&id=9450da1e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=9450da1e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9450da1e"]])

export default __exports__